import { toast } from "react-toastify";
import { AI_SCHEDULE_MATRIX } from "../config/apiEndPoint";
import { GET, GET_V2, POST, POST_V2, PUT, DEL } from "config/api.config";

export const fetchAIScheduleMatrixTableAndFilterSchema = async (data = {}) => {
  try {
    const response = await GET(AI_SCHEDULE_MATRIX.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitAIScheduleMatrixFilterData = async (data = {}) => {
  try {
    const response = await POST(AI_SCHEDULE_MATRIX.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addAIScheduleMatrix = async (data = {}) => {
  try {
    const response = await POST(AI_SCHEDULE_MATRIX.LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateAIScheduleMatrix = async (id, data = {}) => {
  try {
    const response = await PUT(AI_SCHEDULE_MATRIX.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const deleteAIScheduleMatrix = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("Record ID is required");
    return;
  }
  try {
    const response = await DEL(AI_SCHEDULE_MATRIX.BY_ID(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchAIScheduleMatrixByGroup = async (groupId = "") => {
  const raw = String(groupId ?? "").trim();
  if (!raw) {
    return null;
  }
  try {
    const response = await GET_V2(AI_SCHEDULE_MATRIX.BY_GROUP(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchAIScheduleMatrixDays = async () => {
  try {
    const response = await GET_V2(AI_SCHEDULE_MATRIX.DAYS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchAIScheduleMatrixWeekDays = async () => {
  try {
    const response = await GET_V2(AI_SCHEDULE_MATRIX.WEEK_DAYS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Bulk upsert schedule matrix rows (v2). */
export const submitAIScheduleMatrixBulk = async (rows = []) => {
  try {
    const response = await POST_V2(AI_SCHEDULE_MATRIX.LIST, rows);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
